import { useMemo } from 'react'
const usePeerConnection = () => {
  const peerConnection: any = useMemo(() => {
    return new RTCPeerConnection({
      iceServers: [
        {
          urls: 'stun:stun.l.google.com:19302',
        },
        {
          urls: 'stun:stun1.l.google.com:19302',
        },
        {
          urls: 'stun:stun2.l.google.com:19302',
        },
        {
          urls: 'turn:68.183.244.92:3478',
          username: 'supchar',
          credential: 'supchar@turn2025',
        },
      ],
    })
  }, [])
  return peerConnection
}

export default usePeerConnection
